import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import { AppConfig } from './../../app.config';

@Injectable()
export class ChangePasswordService {
    private urlPasswordChange: string = '';

    constructor(private http: HttpClient, private _appConfig: AppConfig) {
        this.urlPasswordChange = _appConfig.getConfig().nPointAuthService + '/auth/pwdchange';
    }

    passwordChange(p_OldPass: string, p_NewPass: string): Observable<number> {
        const l_Data = { oldPwd: p_OldPass, newPwd: p_NewPass };
        return this.http.post(this.urlPasswordChange, l_Data)
            .catch(this.handleError);
    }

    public CheckPasswordPattern(p_password: string, p_pattern: string): boolean {
        switch (p_pattern) {
            case 'length': {
                return !(p_password.length < 8);
            }
            case 'majuscule': {
                return !(!/[A-Z]/.test(p_password));
            }
            case 'minuscule': {
                return !(!/[a-z]/.test(p_password));
            }
            case 'numerique': {
                return !(!/\d/.test(p_password));
            }
            case 'specialCar': {
                return !(!/[@$^&+="]/.test(p_password));
            }

        }
        return false;
    }

    private handleError(err: HttpErrorResponse) {
        let errMsg: string;
        if (err && (err.error instanceof Error)) {
            errMsg = `${err.status} - ${err.statusText || ''} ${err}`;
        } else if (err && err.error) {
            errMsg = (err.error.message ? err.error.message : err.error.toString());
        } else if (typeof err == 'string') {
            errMsg = err;
        }

        return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/in/services/change-password.service.ts